export const ACCESS_TOKEN = 'accessToken';
export const AUDIO_DEVICE_ID = 'audioInputDeviceId';
export const VIDEO_DEVICE_ID = 'videoDeviceId';
